import myAxios from "../utils/request";
export default {
  getList(params) {
    return myAxios.post("/api/News/GetBackEndNewsPaging", params);
  },
  setTop(params) {
    const { id } = params;
    return myAxios.get(`/api/News/BackSetTop?id=${id}`);
  },
  batchDelete(params) {
    return myAxios.post("/api/News/BatchDeleteNews", params);
  }
};
